import { Button, CircularProgress, Box } from "@mui/material";
import { handleDownloadFile } from "../../../api/handleDownloadFile";
import useAuth from "../../../hooks/useAuth";
import { useState } from "react";
import "./DownloadButton.css";
import ReuploadButton from "../ReuploadButton/ReuploadButton";

const DownloadButton = ({ params, type }: { params: any; type: string }) => {
  const { token } = useAuth();
  const [loading, setLoading] = useState(false);

  const handleDownload = async () => {
    setLoading(true);
    try {
      await handleDownloadFile(params.row, type, token);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center", mt: .5 }}>
      <Button
        variant="contained"
        color="primary"
        className="download-button"
        onClick={handleDownload}
        disabled={loading}
      >
        {loading ? (
          <CircularProgress size={24} />
        ) : (
          {
            maintenance: "Download Maintenance Report",
            invoice: "Download Invoice",
            receipt: "Download Receipt",
            moneyRequestInvoice: "Download Invoice",
            moneyRequestReceipt: "Download Receipt",
            yardRepairInvoice: "Download Invoice",
          }[type] || "Download"
        )}
      </Button>
      <ReuploadButton params={params} type={type} />
    </Box>
  );
};

export default DownloadButton;
